import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useJobs } from "../components/JobContext";
import {
  FaBuilding, FaMapMarkerAlt, FaRupeeSign, FaCalendarAlt,
  FaGraduationCap, FaSearch, FaArrowRight, FaFire, FaTimes,
  FaChevronLeft, FaChevronRight,FaBriefcase
} from "react-icons/fa";
import "../styles/Home.css";




const MidJobAd = () => {
  const adRef = React.useRef(null);

  useEffect(() => {
    const container = adRef.current;
    if (!container) return;

    // Clear previous ad
    container.innerHTML = "";

    // Unique container ID (important)
    const uniqueId = `ad-${Math.random().toString(36).substring(2, 10)}`;
    container.id = uniqueId;

    // Create script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
      atOptions = {
        'key' : '8bdce8107f5b55c14c942175d52eea7e',
        'format' : 'iframe',
        'height' : 250,
        'width' : 300,
        'params' : {}
      };
    `;

    const invokeScript = document.createElement("script");
    invokeScript.src = "https://www.highperformanceformat.com/8bdce8107f5b55c14c942175d52eea7e/invoke.js";
    invokeScript.async = true;

    container.appendChild(script);
    container.appendChild(invokeScript);

  }, []);

  return <div ref={adRef} className="mid-job-ad" />;
};


const Home = () => {
  const { jobs = [] } = useJobs();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("All"); // IT / Non-IT / Government
const [jobType, setJobType] = useState("All");   // Full-time / Internship / Part-time
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  

  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 30;
  useEffect(() => {
    document.title = "Latest Jobs | JobKickstart";

    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = "Find latest jobs, internships, and walk-ins.";
    document.head.appendChild(meta);
  }, []);

  useEffect(() => {
    if (jobs.length > 0) {
      setLoading(false);
    } else {
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [jobs]);

  useEffect(() => {
    const timer = setTimeout(() => setShowModal(true), 750000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
  const shown = localStorage.getItem("modalShown");

  if (!shown) {
    const timer = setTimeout(() => {
      setShowModal(true);
      localStorage.setItem("modalShown", "true");
    }, 15000);

    return () => clearTimeout(timer);
  }
}, []);

  const getRecentBadge = (dateString) => {
    if (!dateString) return null;

    const today = new Date();
    const jobDate = new Date(dateString);

    today.setHours(0,0,0,0);
    jobDate.setHours(0,0,0,0);

    const diffDays = Math.floor((today - jobDate) / (1000*60*60*24));

    if(diffDays === 0) return "Today";
    if(diffDays === 1) return "Yesterday";
    return `${diffDays} days ago`;
  };

 const allFilteredJobs = jobs
  .filter(job => {
    // Category filter
    if (category === "All") return true;
    return job.category === category; // job.category should be IT / Non-IT / Government
  })
  .filter(job => {
    // Job type filter
    if (jobType === "All") return true;
    return job.jobType === jobType; // Full-time / Internship / Part-time / Walk-in
  })
  .filter(job => {
    const s = searchTerm.toLowerCase();
    return (
      job.title?.toLowerCase().includes(s) ||
      job.company?.toLowerCase().includes(s)
    );
  })
  .sort((a, b) => new Date(b.postedDate) - new Date(a.postedDate));

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;

  const paginatedJobs = allFilteredJobs.slice(indexOfFirstJob,indexOfLastJob);
  const totalPages = Math.ceil(allFilteredJobs.length / jobsPerPage);

  /* SCROLL ANIMATION OBSERVER */

  useEffect(()=>{

    if(loading) return;

    const observer = new IntersectionObserver((entries)=>{

      entries.forEach(entry=>{
        if(entry.isIntersecting){
          entry.target.classList.add("show");
        }else{
          entry.target.classList.remove("show");
        }
      });

    },{
      threshold:0.2
    });

    const cards = document.querySelectorAll(".reveal-card");
    cards.forEach(card=>observer.observe(card));

    return ()=>observer.disconnect();

  },[loading,paginatedJobs]);
const recentJobs = paginatedJobs.filter(job => {
  const badge = getRecentBadge(job.postedDate);
  return badge === "Today" || badge === "Yesterday";
});

const olderJobs = paginatedJobs.filter(job => {
  const badge = getRecentBadge(job.postedDate);
  return badge && badge.includes("days ago");
});

useEffect(() => {
  if (category === "Government" || category === "All") {
    setJobType("All");
  }
}, [category]);

  const scrollToTop = ()=> window.scrollTo({top:0,behavior:"smooth"});

  if(loading){
    return(
      <div className="job-loader-wrap">
        <div className="job-spinner"></div>
      </div>
    );
  }

  return (

<div className="job-home-wrapper">

{showModal && (
<div className="interview-modal-overlay">
<div className="interview-modal-box">

<button
className="modal-close-btn"
onClick={()=>setShowModal(false)}
>
<FaTimes/>
</button>

<h2>🎯 Preparing for a Job?</h2>

<p>
Boost your chances by checking our
<strong> Interview Preparation Guide</strong>.
</p>

<button
className="modal-action-btn"
onClick={()=>{
setShowModal(false);
navigate("/interview");
}}
>
Start Preparation
</button>

</div>
</div>
)}

<section className="hero-section">

<h1>
Find Your Next <span>Tech Career</span>
</h1>

<p>
Latest jobs, internships and hiring challenges from top companies.
</p>

<div className="search-box">

<FaSearch className="search-icon"/>

<input
type="text"
placeholder="Search role, company or skills..."
value={searchTerm}
onChange={(e)=>setSearchTerm(e.target.value)}
/>

</div>
{/* CATEGORY FILTER */}
<div className="tab-group">
  {["All", "IT", "Non-IT", "Government"].map(tab => (
    <button
      key={tab}
      className={category === tab ? "active-tab" : ""}
      onClick={() => setCategory(tab)}
    >
      {tab}
    </button>
  ))}
</div>

{/* ✅ SHOW ONLY FOR IT / NON-IT */}
{(category === "IT" || category === "Non-IT") && (
  <div className="tab-group">
    {["All", "Full-Time", "Part-Time", "Internship", "Walk-In"].map(type => (
      <button
        key={type}
        className={jobType === type ? "active-tab" : ""}
        onClick={() => setJobType(type)}
      >
        {type}
      </button>
    ))}
  </div>
)}

</section>


{currentPage===1 && !searchTerm && (

<section className="trending-section">

<h2>🔥 Trending Hiring</h2>

<div className="trending-grid">

{jobs.slice(0,6).map(job=>(
<div
key={job.id}
className="trending-card"
onClick={()=>navigate(`/job/${job.id}`)}
>

<h3>{job.title}</h3>

<p>
<FaBuilding/> {job.company}
</p>

<span>
<FaMapMarkerAlt/> {job.location}
</span>

</div>
))}

</div>
</section>
)}

<section className="jobs-section">

<div className="section-header">
<h2>Latest Opportunities</h2>
<span className="results-count">
{allFilteredJobs.length} jobs found
</span>
</div>

{recentJobs.length>0 && (

<div className="job-grid">

{recentJobs.map((job, index) => (
              <React.Fragment key={job.id}>

<div
key={job.id}
className="job-card reveal-card"
onClick={()=>navigate(`/job/${job.id}`)}
>

<div className="badge-container">

  {job.category === "Government" && (
    <div className="gov-badge">
      🏛 Govt Job
    </div>
  )}

  {getRecentBadge(job.postedDate) && (
    <div className="new-badge">
      <FaFire /> {getRecentBadge(job.postedDate)}
    </div>
  )}

</div>
<div className="job-header">

<div className="logo">
{job.imageUrl ? (
<img
src={job.imageUrl}
alt={job.title}
style={{
width:"40px",
height:"40px",
borderRadius:"50%"
}}
/>
) : job.title?.charAt(0)}
</div>

<div className="title-area">
<h3>{job.title}</h3>
<p className="company-name">{job.company}</p>
</div>

</div>

<div className="job-info">

  <p><FaMapMarkerAlt /> {job.location || "Location not mentioned"}</p>
  <p><FaRupeeSign /> {job.salary || "Salary not mentioned"}</p>
  <p><FaGraduationCap /> {job.experience || "Experience not mentioned"}</p>
  <p><FaBriefcase /> vacancies : {job.vacancies || "not mentioned"}</p>
  <p>
    <FaCalendarAlt />{" "}
    {job.postedDate
      ? new Date(job.postedDate).toLocaleDateString()
      : "Date not mentioned"}
  </p>

</div>

<button className="view-btn">
View Details <FaArrowRight/>
</button>

</div>
{/* 🔥 AD AFTER EVERY 5 JOBS */}
  {(index + 1) % 5 === 0 && (
  <div className="ad-wrapper">
    <MidJobAd />
  </div>
)}
  </React.Fragment>

))}

</div>
)}

{olderJobs.length > 0 && (

<div className="older-jobs-section">

<h3>Older Jobs</h3>

{/* 🔥 AD 1: Top of older jobs */}





<div className="job-grid">

{olderJobs.map((job, index) => (

<React.Fragment key={job.id}>

<div
className="job-card reveal-card"
onClick={() => navigate(`/job/${job.id}`)}
>

{getRecentBadge(job.postedDate) && (
<div className="new-badge">
<FaFire /> {getRecentBadge(job.postedDate)}
</div>
)}

<div className="job-header">

<div className="logo">
{job.imageUrl ? (
<img
src={job.imageUrl}
alt={job.title}
style={{
width: "40px",
height: "40px",
borderRadius: "50%"
}}
/>
) : job.title?.charAt(0)}
</div>

<div className="title-area">
<h3>{job.title}</h3>
<p className="company-name">{job.company}</p>
</div>

</div>

<div className="job-info">

<p><FaMapMarkerAlt /> {job.location}</p>
<p><FaRupeeSign /> {job.salary}</p>
<p><FaGraduationCap /> {job.experience}</p>
<p><FaCalendarAlt /> {new Date(job.postedDate).toLocaleDateString()}</p>

</div>

<button className="view-btn">
View Details <FaArrowRight />
</button>

</div>

{/* 🔥 AD AFTER EVERY 5 JOBS */}
{(index + 1) % 5 === 0 && (
  <div className="ad-wrapper">
    <MidJobAd />
  </div>
)}

</React.Fragment>

))}

</div>

{/* 🔥 AD 2: Bottom of older jobs */}
<script async="async" data-cfasync="false" src="https://pl29306020.profitablecpmratenetwork.com/43462600380fb661a0d2f51e481cb476/invoke.js"></script>
<div id="container-43462600380fb661a0d2f51e481cb476"></div>


</div>
)}

{totalPages>1 && (

<div className="pagination-wrapper">

<button
className="page-control"
disabled={currentPage===1}
onClick={()=>{
setCurrentPage(p=>p-1);
scrollToTop();
}}
>
<FaChevronLeft/>
</button>

{[...Array(totalPages)].map((_,i)=>(
<button
key={i+1}
className={`page-number ${currentPage===i+1 ? "active" : ""}`}
onClick={()=>{
setCurrentPage(i+1);
scrollToTop();
}}
>
{i+1}
</button>
))}

<button
className="page-control"
disabled={currentPage===totalPages}
onClick={()=>{
setCurrentPage(p=>p+1);
scrollToTop();
}}
>
<FaChevronRight/>
</button>

</div>
)}

</section>

</div>
  );
};

export default Home;